export const BACKEND_YSY = "https://api.yoursynchronicity.com";

export const CALLBACK_UI_COGNITO = 'https://www.yoursynchronicity.com';
export const API_KEY_CLIENT = '14la992522it9l4gke47sduju';
export const API_SECRET_KEY = '19pkmlbkf334t8b46ep7g09ho7t55gjhtl8gmn77ie3gj6thi959';

//
// export const CALLBACK_UI_COGNITO = "http://localhost:8080";
// export const API_KEY_CLIENT = '23hbvnv9ofhfj903skof5jrfgk';
// export const API_SECRET_KEY = '1kea5n7be6t5k816qrnil0olam46vdfi21ber6kll7vp4micvae6';

